/* eslint-disable react/prop-types */
function CloseOneIcon({className, stroke = "#000000", size = "24px"}) {
  return (
    <svg className={className} viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path fill={stroke} d="m16.03,15.01l4.49-4.49c.15-.15.23-.33.24-.54,0-.2-.07-.39-.21-.54-.14-.15-.33-.23-.53-.23-.23,0-.39.07-.54.21l-4.51,4.51-4.49-4.49c-.3-.31-.77-.31-1.08-.02-.15.14-.23.33-.23.53,0,.2.07.39.21.54l4.51,4.51-4.49,4.49c-.29.29-.29.77,0,1.07.29.29.77.29,1.07,0l4.49-4.49,4.49,4.49c.14.13.29.21.53.21.2,0,.39-.09.53-.23.28-.29.28-.76,0-1.05l-4.48-4.48Z"/>
      <path fill={stroke} d="m14.96,29.96C6.71,29.96,0,23.25,0,15S6.71.04,14.96.04s14.96,6.71,14.96,14.96-6.71,14.96-14.96,14.96Zm0-28.91C7.26,1.04,1,7.3,1,15s6.26,13.96,13.96,13.96,13.96-6.26,13.96-13.96S22.65,1.04,14.96,1.04Z"/>
    </svg>
  )
}

export default CloseOneIcon